import script from "./session-time.vue?vue&type=script&setup=true&lang=js"
export * from "./session-time.vue?vue&type=script&setup=true&lang=js"

import "./session-time.vue?vue&type=style&index=0&id=05dc04c8&lang=scss"

const __exports__ = script;

export default __exports__